import { ColoursObj, Icon } from "@eventr/common-storybook";
import { useObjectContext } from "../providers/objectProvider";
import { CardText } from "./cardText";
import { RowInfo } from "./rowInfo";

interface IRowInfoPhoneProps {
  phoneNumber: string;
}
export const RowInfoPhone = ({ phoneNumber }: IRowInfoPhoneProps) => {
  const { past } = useObjectContext();

  return (
    <RowInfo
      start={
        <Icon
          name="Contact_Phone"
          bubble
          bubbleColour={past ? ColoursObj.shades.shade2 : ColoursObj.coreBrights.primary}
        />
      }
      middle={
        <CardText
          variant="bodyBoldUnderlined"
          onClick={(e) => {
            window.location.href = `tel:${phoneNumber}`;
            e.stopPropagation();
          }}
        >
          {phoneNumber}
        </CardText>
      }
    />
  );
};
